import { StatisticalUnit } from './StatisticalUnit';

export default StatisticalUnit;
